var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1024.001 188.632v107.789h-1024v-107.789h1024zM862.316 458.105v107.789h-862.316v-107.789h862.316zM700.632 727.579v107.789h-700.632v-107.789h700.632z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBars);
export default __webpack_public_path__ + "static/media/icon-bars.dfa805b20392c4c4bb8ed75ff59030bb.svg";
export { ForwardRef as ReactComponent };